import React from 'react';
import { Typography } from '@material-ui/core';
import { createStyles, makeStyles } from '@material-ui/core/styles';
import { UnscheduledAlertBodyProps } from './UnscheduledAlertBodyProps';
import AlertDetails from '@components/Alerts/presentationComponents/AlertDetails';

const useStyles = makeStyles((theme) => createStyles({
	root: {
		paddingTop: theme.spacing(2),
	},
}));

export const UnscheduledAlertBody = (descriptionProps: UnscheduledAlertBodyProps) => {
	const classes = useStyles();

	return (
		<AlertDetails>
			<Typography
				className={classes.root}
				variant="body2"
			>
				{descriptionProps.description}
			</Typography>
		</AlertDetails>
	);
};
